import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { YatPageV2 } from '@app/client/resources/yat-pages';
import { getAppUrl } from '@app/helpers';
import { YAT_PROFILE_PAGE } from '@app/routes/paths';

export function useProfile() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const primaryYat = useAppSelector((state) => state.user.userAccount?.user.eid);

    interface RedirectToProfileOptions {
        hardRedirect?: boolean;
    }

    const redirectToProfile = useCallback(
        async ({ hardRedirect }: RedirectToProfileOptions = {}) => {
            let profileAlias = YAT_PROFILE_PAGE;
            if (!primaryYat) {
                // TODO: This should be refactored once the new user store is in place.
                // The only purpose of this query is to identify the primary Yat of the user
                // so that we can redirect them to their profile page without multiple redirects
                const yatPage = await queryClient.fetchQuery({
                    queryKey: ['yatPageV2', 'profile'],
                    queryFn: ({ signal }) => YatPageV2.callGetYatPageProfile({ settings: { signal } }),
                    retry: false,
                });

                if (yatPage && yatPage.ok && yatPage.value?.eid) {
                    profileAlias = yatPage.value?.eid;
                }
            }

            if (hardRedirect) {
                window.location.href = getAppUrl(profileAlias);
            } else {
                navigate(profileAlias);
            }
        },
        [navigate, primaryYat, queryClient],
    );

    return { redirectToProfile };
}
